export type CollectionHandler<T> =
{
    getCurrentItem?: () => T, //Get the currently selected item.
    setCurrentItem?: (item: T) => void, //Select the specified item if it is in the collection.
    hasItem?: (item: T) => boolean, //Returns true if the specified item is in the collection.
    getNextItem: (item?: T) => T, //If an argument is passed, selects that item.  Then, selects the next item (rotating from the end of the list to the start) and returns it.
    getPreviousItem: (item?: T) => T //If an argument is passed, selects that item.  Then, selects the previous item (rotating from the start of the list to the end) and returns it.
};

/**
* Create a collection handler for an array-like collection
* @param {Array<T>|JQuery<T>} collectionToHandle The collection to wrap
* @returns {CollectionHandler<T>} A collection handler
*/
export function createCollectionHandler<T>(collectionToHandle: Array<T> | JQuery<T>): CollectionHandler<T>
{
    let currentIndex = -1;
    const collection = collectionToHandle || [];

    const collectionHandler: CollectionHandler<T> = {
        getCurrentItem: function (): T {
            if (currentIndex === -1) {
                currentIndex = 0;
            }
            return collection[currentIndex];
        },
        setCurrentItem: function (newCurrentItem: T): void {
            currentIndex = $.inArray(newCurrentItem, collection as T[]);
        },
        hasItem: function (itemToCheck: T): boolean {
            return $.inArray(itemToCheck, collection as T[]) > -1;
        },
        getNextItem: function (currentItem?: T): T {
            let index = $.inArray(currentItem, collection as T[]);
            if (index === -1) {
                index = currentIndex;
            }

            if (index === -1) {
                index = 0;
            } else if (index >= collection.length - 1) {
                index = 0;
            } else {
                index++;
            }
            currentIndex = index;
            return collection[currentIndex];
        },
        getPreviousItem: function (currentItem?: T): T {
            let index = $.inArray(currentItem, collection as T[]);
            if (index === -1) {
                index = currentIndex;
            }

            if (index === -1) {
                index = 0;
            } else if (index <= 0) {
                index = collection.length - 1;
            } else {
                index--;
            }
            currentIndex = index;
            return collection[currentIndex];
        }
    };

    return collectionHandler;
}